import { adminPanelBilligService } from '../../../services';

export const config: any = {
  getAllFeatures: () => adminPanelBilligService.getAllFeatures(),
  addPlanFeatures: (params: any) =>
    adminPanelBilligService.addPlanFeatures(params),
  getActiveSub: () => adminPanelBilligService.getActiveSub(),
  getAllBillingRequests: () => adminPanelBilligService.getAllBillingRequests(),
  setBillingRequest: (params: any) =>
    adminPanelBilligService.setBillingRequest(params),
  getOrgBillingHistory: (params: string) =>
    adminPanelBilligService.getOrgBillingHistory(params),
  downloadInvoice: (params: any) =>
    adminPanelBilligService.downloadInvoice(params),
};
